import { FaCheck, FaTimesCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import U2000ActionBtn from '../buttons/U2000ActionBtn';
import U2000BasicDialog from './U2000BasicDialog';

interface U2000FormLeaveConfirmDialogProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirmation perte de saisie (BL-0635) — navigation, déconnexion, etc. */
const U2000FormLeaveConfirmDialog: React.FC<U2000FormLeaveConfirmDialogProps> = ({ isOpen, onConfirm, onCancel }) => {
  const { t } = useTranslation('common');

  return (
    <U2000BasicDialog
      isOpen={isOpen}
      onClose={() => onCancel()}
      title={t('formLeave.confirmTitle')}
      width="w-[420px]"
      overlayClassName="z-[1100]"
    >
      <div className="flex flex-col items-center justify-center p-4 text-center">
        <p className="text-sm text-gray-700">{t('formLeave.confirmMessage')}</p>
      </div>
      <div className="mt-2 flex justify-center gap-x-2 border-t-2 border-gray-300 p-4">
        <U2000ActionBtn label={t('formLeave.confirmAction')} icon={FaCheck} handleClick={onConfirm} />
        <U2000ActionBtn label={t('formLeave.confirmCancel')} icon={FaTimesCircle} handleClick={onCancel} variant="secondary" />
      </div>
    </U2000BasicDialog>
  );
};

export default U2000FormLeaveConfirmDialog;
